import type { ReactNode } from 'react';
import styles from './FormSectionTitle.module.css';

export interface FormSectionTitleProps {
	children: ReactNode;
	size?: 'default' | 'small' | 'xsmall';
}

export const FormSectionTitle = ({ children, size = 'default' }: FormSectionTitleProps) => (
	<div className={`${styles.title} ${size === 'default' ? '' : styles[size]}`}>{children}</div>
);
